declare const __FACTSET_AUTO_SSO_ENABLED__: boolean;

export function shouldAttemptFactSetAutoLogin(): boolean {
  return typeof __FACTSET_AUTO_SSO_ENABLED__ !== "undefined" && __FACTSET_AUTO_SSO_ENABLED__;
}
